var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.1222C5.3 12.4611 4.49792 11.9556 3.59375 11.6056C2.68958 11.2556 1.74167 11.0806 0.75 11.0806V4.6639C1.73194 4.6639 2.675 4.84123 3.57917 5.1959C4.48333 5.55095 5.29028 6.0639 6 6.73473C6.70972 6.0639 7.51667 5.55095 8.42083 5.1959C9.325 4.84123 10.2681 4.6639 11.25 4.6639V11.0806C10.2486 11.0806 9.29836 11.2556 8.39925 11.6056C7.49975 11.9556 6.7 12.4611 6 13.1222ZM6 5.24723C5.35833 5.24723 4.80903 5.01876 4.35208 4.56182C3.89514 4.10487 3.66667 3.55557 3.66667 2.9139C3.66667 2.27223 3.89514 1.72293 4.35208 1.26598C4.80903 0.809039 5.35833 0.580566 6 0.580566C6.64167 0.580566 7.19097 0.809039 7.64792 1.26598C8.10486 1.72293 8.33333 2.27223 8.33333 2.9139C8.33333 3.55557 8.10486 4.10487 7.64792 4.56182C7.19097 5.01876 6.64167 5.24723 6 5.24723Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLibrary);
export default __webpack_public_path__ + "static/media/local_library.37ec217cbb109f73658b0b155d203afc.svg";
export { ForwardRef as ReactComponent };